import { render } from "./InputButton.vue?vue&type=template&id=0a9eca9f&scoped=true"
import script from "./InputButton.vue?vue&type=script&lang=js"
export * from "./InputButton.vue?vue&type=script&lang=js"

import "./InputButton.vue?vue&type=style&index=0&id=0a9eca9f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9eca9f"]])

export default __exports__